<template>
    <slot />
  </template>
  
  <script>
  import {
    createApp,
    onMounted,
    onBeforeUnmount,
    ref,
  } from "vue";
  import PaginaQuestionarioWrapperWC from './PaginaQuestionarioWrapperWC.vue'
  import "bootstrap";
  import "bootstrap/dist/css/bootstrap.min.css";
  import store from '../store/index'
  
  
  export default {
    props: {
     
        domId: {
          type: String,
          default: null
        },
        email: {
          type: String,
          default: null
        },
        password: {
          type: String,
          default: null
        },
        basePath: {
          type: String,
          default: null
        },
        ricordaRisposteQuestionario: {
          type: String,
          default: 'false'
        },
        questionarioId: {
          type: String,
          default: null
        },
        surveyId: {
          type: String,
          default: null
        },
        lastSurveyLocalstorageId: {
          type: String,
          default: 'id_survey_log_not_ended'
        },
        joomlaArticoloBasePath: {
          type: String,
          default: ''
        },
        joomlaDocumentiUtiliBasePath: {
          type: String,
          default: ''
        },
        isJoomla5: {
          type: String,
          default: 'false'
        },
        tokenId: {
          type: String,
          default: ''
        },
        startFromAnswerId: {
          type: String,
          default: ''
        },
        urlChiusoPerFerie: {
          type: String,
          default: ''
        },
        chiusoPerFerie: {
          type: String,
          default: ''
        },
        chiusoPerFerieDal: {
          type: String,
          default: ''
        },
        chiusoPerFerieAl: {
          type: String,
          default: ''
          //2023-07-24T16:30:00+02:00
        },
        chiudiInbound: {
          type: String,
          default: ''
        },
        chiudiInboundDal: {
          type: String,
          default: ''
        },
        chiudiInboundAl: {
          type: String,
          default: ''
        },
        idsAnswerTerminaleAlert: {
          type: String,
          default: ''
        },
        minutiTimerInbound: {
          type: String,
          default: ''
        },
        tocUrl: {
          type: String,
          default: ''
        },
        scrollOnTicketForm: {
          type: String,
          default: ''
        },
       
    },
  /*   components: {
      PaginaQuestionarioWrapperWC : PaginaQuestionarioWrapperWC
      //'erroreGenerico': ErroreGenerico
    }, */
  
    setup(props) {
      const app = createApp(PaginaQuestionarioWrapperWC, {
        libraryWiperConfig: {
            email: props.email,
            password: props.password,
            basePath: props.basePath,
            ricordaRisposteQuestionario: props.ricordaRisposteQuestionario,
            questionarioId: props.questionarioId,
            surveyId: props.surveyId,
            lastSurveyLocalstorageId: props.lastSurveyLocalstorageId,
            joomlaArticoloBasePath: props.joomlaArticoloBasePath,
            joomlaDocumentiUtiliBasePath: props.joomlaDocumentiUtiliBasePath,
            isJoomla5: props.isJoomla5,
            tokenId: props.tokenId,
            chiusoPerFerie: props.chiusoPerFerie,
            urlChiusoPerFerie: props.urlChiusoPerFerie,
            chiusoPerFerieDal: props.chiusoPerFerieDal,
            chiusoPerFerieAl: props.chiusoPerFerieAl,
            chiudiInbound: props.chiudiInbound,
            chiudiInboundDal: props.chiudiInboundDal,
            chiudiInboundAl: props.chiudiInboundAl,
            idsAnswerTerminaleAlert: props.idsAnswerTerminaleAlert,
            minutiTimerInbound: props.minutiTimerInbound,
            tocUrl: props.tocUrl,
            scrollOnTicketForm: props.scrollOnTicketForm,
            startFromAnswerId: props.startFromAnswerId
          },
  
      });
  
      app.use(store)
   
  
      onMounted(() => {
        // JwtService.getPlatoneToken();
  
        if (document.getElementById(props.domId)) {
          app.mount("#" + props.domId);
        }
      });
  
      onBeforeUnmount(() => {
        console.log("unmount WC");
      });
  
      return {};
    },
  };
  </script>
  
  <style lang="scss"></style>
  